/**
 * Tenant-API response envelope unwrapper.
 *
 * The canonical member-facing endpoints (the ones the live Angular
 * `member-portal` consumes) wrap every payload in `{ success, data }` —
 * and paginated lists in `{ success, data, pagination }`. This helper
 * pulls the inner `data` out so feature `api.ts` modules can return plain
 * domain objects.
 *
 * It is tolerant: a bare object/array (no envelope) passes straight
 * through, so it is safe to wrap every call.
 */
export function unwrap<T>(body: unknown): T {
  if (body && typeof body === 'object' && 'data' in (body as Record<string, unknown>)) {
    return (body as { data: T }).data;
  }
  return body as T;
}

/** Unwrap a list payload, coercing a missing/non-array `data` to `[]`. */
export function unwrapList<T>(body: unknown): T[] {
  const data = unwrap<T[] | undefined>(body);
  return Array.isArray(data) ? data : [];
}
